/**
 * Script de diagnóstico para categorías habilitadas
 */

// Exportar para que TypeScript considere esto un módulo
export {};

// Función de diagnóstico completo
(window as any).diagnoseCategories = async function() {
  console.log('🔍 Iniciando diagnóstico de categorías...');
  
  try {
    // Verificar si Firebase está inicializado
    console.log('1️⃣ Verificando Firebase...');
    if (typeof window !== 'undefined' && (window as any).auth) {
      console.log('✅ Firebase disponible en window.auth');
      console.log('   - db:', typeof (window as any).auth.db);
      console.log('   - auth:', typeof (window as any).auth.auth);
      console.log('   - storage:', typeof (window as any).auth.storage);
    } else {
      console.log('❌ Firebase no disponible en window.auth');
      return;
    }
    
    // Verificar servicio optimizado
    console.log('\n2️⃣ Verificando servicio optimizado...');
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    console.log('✅ Servicio optimizado importado');
    
    // Verificar usuario autenticado
    console.log('\n3️⃣ Verificando usuario autenticado...');
    const userId = (window as any).auth.auth.currentUser?.uid;
    if (userId) {
      console.log('✅ Usuario autenticado:', userId);
    } else {
      console.log('❌ Usuario no autenticado');
      return;
    }
    
    // Obtener categorías
    console.log('\n4️⃣ Obteniendo categorías...');
    const categories = await optimizedService.getCategories();
    console.log(`📊 Total de categorías encontradas: ${categories.length}`);
    
    if (categories.length === 0) {
      console.log('⚠️ No hay categorías en la base de datos');
      console.log('💡 Creando categorías de prueba...');
      
      const testCategories = [
        { name: 'Campera', fields: { material: { type: 'text', required: true } } },
        { name: 'Buzo', fields: { material: { type: 'text', required: true } } },
        { name: 'Remera', fields: { material: { type: 'text', required: true } } }
      ];
      
      for (const categoryData of testCategories) {
        try {
          const categoryName = await optimizedService.createCategory(categoryData);
          console.log(`✅ Categoría "${categoryData.name}" creada`);
        } catch (error) {
          console.log(`⚠️ Error creando "${categoryData.name}":`, error instanceof Error ? error.message : error);
        }
      }
      
      // Recargar categorías
      const newCategories = await optimizedService.getCategories();
      console.log(`📊 Nuevas categorías: ${newCategories.length}`);
    }
    
    // Mostrar detalles de cada categoría
    console.log('\n5️⃣ Detalles de categorías:');
    const finalCategories = await optimizedService.getCategories();
    finalCategories.forEach((category, index) => {
      console.log(`   ${index + 1}. ${category.name} (${category.id})`);
      console.log(`      - enabled: ${category.enabled}`);
      console.log(`      - createdAt: ${category.createdAt}`);
      console.log(`      - fields: ${Object.keys(category.fields).length} campos`);
    });
    
    // Probar actualización
    if (finalCategories.length > 0) {
      console.log('\n6️⃣ Probando actualización...');
      const firstCategory = finalCategories[0];
      console.log(`🔄 Actualizando categoría "${firstCategory.name}"...`);
      
      try {
        await optimizedService.updateCategory(firstCategory.id, { enabled: true });
        console.log('✅ Actualización exitosa');
        
        // Verificar cambio
        const updatedCategories = await optimizedService.getCategories();
        const updatedCategory = updatedCategories.find(cat => cat.id === firstCategory.id);
        console.log(`📊 Estado después de actualización: ${updatedCategory?.enabled}`);
        
      } catch (error) {
        console.log('❌ Error en actualización:', error instanceof Error ? error.message : error);
      }
    }
    
    console.log('\n🎉 Diagnóstico completado');
    return {
      firebaseAvailable: !!(window as any).auth,
      userAuthenticated: !!userId,
      categoriesCount: finalCategories.length,
      categories: finalCategories
    };
    
  } catch (error) {
    console.error('❌ Error en diagnóstico:', error);
    throw error;
  }
};

// Función para verificar solo el estado de Firebase
(window as any).checkFirebase = function() {
  console.log('🔍 Verificando estado de Firebase...');
  
  if (typeof window !== 'undefined' && (window as any).auth) {
    const auth = (window as any).auth;
    console.log('✅ Firebase disponible');
    console.log('   - db:', typeof auth.db);
    console.log('   - auth:', typeof auth.auth);
    console.log('   - storage:', typeof auth.storage);
    console.log('   - collection:', typeof auth.collection);
    console.log('   - doc:', typeof auth.doc);
    console.log('   - setDoc:', typeof auth.setDoc);
    console.log('   - getDocs:', typeof auth.getDocs);
    console.log('   - updateDoc:', typeof auth.updateDoc);
    console.log('   - deleteDoc:', typeof auth.deleteDoc);
    
    if (auth.auth.currentUser) {
      console.log('✅ Usuario autenticado:', auth.auth.currentUser.uid);
    } else {
      console.log('❌ Usuario no autenticado');
    }
    
    return true;
  } else {
    console.log('❌ Firebase no disponible');
    return false;
  }
};

// Función para crear categorías de prueba
(window as any).createTestCategories = async function() {
  console.log('🧪 Creando categorías de prueba...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    const testCategories = [
      { name: 'Campera', fields: { material: { type: 'text', required: true } } },
      { name: 'Buzo', fields: { material: { type: 'text', required: true } } },
      { name: 'Remera', fields: { material: { type: 'text', required: true } } },
      { name: 'Pantalón', fields: { material: { type: 'text', required: true } } }
    ];
    
    const results = [];
    
    for (const categoryData of testCategories) {
      try {
        const categoryName = await optimizedService.createCategory(categoryData);
        results.push({ name: categoryData.name, id: categoryName, success: true });
        console.log(`✅ "${categoryData.name}" creada`);
      } catch (error) {
        results.push({ name: categoryData.name, success: false, error: error instanceof Error ? error.message : error });
        console.log(`❌ Error con "${categoryData.name}":`, error instanceof Error ? error.message : error);
      }
    }
    
    console.log('🎉 Creación de categorías de prueba completada');
    return results;
    
  } catch (error) {
    console.error('❌ Error creando categorías de prueba:', error);
    throw error;
  }
};

console.log('🔍 Scripts de diagnóstico cargados:');
console.log('- window.diagnoseCategories() - Diagnóstico completo');
console.log('- window.checkFirebase() - Verificar Firebase');
console.log('- window.createTestCategories() - Crear categorías de prueba');
